import React from "react";
import {
  Dialog,
  DialogContent,
  Typography,
  Button,
  Box,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import BusinessIcon from "@mui/icons-material/Business";
import WorkOutlineIcon from "@mui/icons-material/WorkOutline";
import ScheduleIcon from "@mui/icons-material/Schedule";
import { useNavigate } from "react-router-dom";
import { EMPLOYEE_SETUP_ROWS } from "../../../Utils/employeeSetupConfig";

const ROW_ICONS = {
  departments: { Icon: BusinessIcon, iconColor: "#e53935" },
  designations: { Icon: WorkOutlineIcon, iconColor: "#fb8c00" },
  workShifts: { Icon: ScheduleIcon, iconColor: "#1e88e5" },
};

function EmployeeOrganizationalSetupDialog({ open, onClose, missing = {} }) {
  const navigate = useNavigate();

  const visibleRows = EMPLOYEE_SETUP_ROWS.filter((row) => missing[row.key]);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: { borderRadius: 2, p: 0.5 },
      }}
    >
      <DialogContent sx={{ p: 3, position: "relative" }}>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{ position: "absolute", right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>

        <Typography variant="h6" sx={{ fontWeight: 700, pr: 4, mb: 0.5 }}>
          Required Organizational Setup Missing
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          Please add the missing departments, designations, or work shifts
          before you can add an employee.
        </Typography>

        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          {visibleRows.map((row) => {
            const { Icon, iconColor } = ROW_ICONS[row.key] || {};
            return (
              <Box
                key={row.key}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: 2,
                  flexWrap: "wrap",
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                  {Icon ? (
                    <Icon sx={{ color: iconColor, fontSize: 28 }} />
                  ) : null}
                  <Typography variant="body2" color="text.secondary">
                    {row.message}
                  </Typography>
                </Box>
                <Button
                  variant="contained"
                  size="small"
                  onClick={() => {
                    onClose();
                    navigate(row.route);
                  }}
                  sx={{
                    textTransform: "uppercase",
                    fontWeight: 600,
                    whiteSpace: "nowrap",
                  }}
                >
                  {row.buttonLabel}
                </Button>
              </Box>
            );
          })}
        </Box>
      </DialogContent>
    </Dialog>
  );
}

export default EmployeeOrganizationalSetupDialog;
